import { IonAccordion, IonAccordionGroup, IonAlert, IonButton, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonPage, IonRadio, IonRadioGroup, IonRow, IonSelect, IonSelectOption, IonText, IonTextarea } from "@ionic/react"
import React, { useCallback, useContext, useEffect, useRef, useState } from "react"
import InnerMenu from "../components/InnerMenu";
import { ActionType, AuthContext } from "../context/AuthContext";
import { Redirect } from "react-router-dom";
import GpsSinglePointComponent from "../components/GpsSinglePointComponent";
import Map, { Marker, GeolocateControl, MarkerDragEvent, MapRef , Source, Layer, Popup} from 'react-map-gl';
import './Meatori.css'
import { BASE_URL, Buoy, Signal } from "../utils/constant";
import { Controller, useForm } from 'react-hook-form'
import { localStore } from "../App";
import CustomDropdown from '../components/CustomDropDown';
import { informationCircleOutline } from "ionicons/icons";
import SignsService from '../services/SignsService';
import PageEventHandler from "../components/PageEventHandler";

const Meatori: React.FC = () => {
    const pageName = "Operatori del Fiume Po";
    const { state: { user }, dispatch } = useContext(AuthContext)
    const [userCoords, setUserCoords] = useState<any | null>(null)
    const MAPBOX_TOKEN = 'pk.eyJ1IjoiYWxlLWFydCIsImEiOiJjbDFxbWxqa2wwZTNlM2xvM3M4bTEzZGpiIn0.HoRycofAyQPZ33Niv-XRtA'; // Set your mapbox token here
    const [marker, setMarker] = useState({
        latitude: 45.180637,
        longitude: 9.148688
    });
    const [styleLoaded, setStyleLoaded] = useState(false)
    const [showAlert, setShowAlert] = useState(false);
    const [editingStart, setEditingStart] = useState(false);
    // const { control, handleSubmit, watch } = useForm()
    const [message, setMessage] = useState('')
    const mapRef = useRef<MapRef>(null);
    const [selectedSignal, setSelectedSignal] = useState<any>('')
    const [selectedSignIndex, setSelectedSignIndex] = useState<number | null>(null);
    const [showInfo, setShowInfo] = useState(false);
    const [userRotation, setUserRotation] = useState(0); // Store the user rotation of the map (manually set with pinch gesture)
    const [signsList, setSignsList] = useState<[any] | null>(null);
    const signsService = new SignsService();
    const [editingSignIndex, setEditingSignIndex] = useState<number | null>(null);

    const [originalPosition, setOriginalPosition] = useState({longitude: 0, latitude: 0});
    const [position, setPosition] = useState({longitude: 0, latitude: 0});

    useEffect(() => {
      // get signs from memory or server
      fetchSigns();
    }, [])

    useEffect(() => {
        if (userCoords)
            setMarker({ latitude: userCoords.latitude, longitude: userCoords.longitude })
    }, [userCoords])

    function activateGeolocator() {
        if (!styleLoaded) {
            (document.getElementsByClassName("mapboxgl-ctrl-geolocate")[0] as HTMLElement).click();
            setStyleLoaded(true);
        }
    }

  // Update the map handler to handle manual map rotation
  const handleRotationChange = (newRotation: number) => 
  {
    setUserRotation(newRotation);
  }

    const onMarkerDragStart = useCallback((event: MarkerDragEvent) => {
        console.log("start : ", event)

    }, []);

    const onMarkerDrag = useCallback((event: MarkerDragEvent) => {
        // console.log("drg : ", event)
    }, []);

    const onMarkerDragEnd = useCallback((event: MarkerDragEvent) => {
        console.log("end : ", event)
        setMarker({
            longitude: event.lngLat.lng,
            latitude: event.lngLat.lat
        });
    }, []);

    const addSignalPoint = async (data: any) => {
        console.log("addMekPoint : ", data);

        if (!data) 
        {
            setMessage("Seleziona il segnale o la boa da aggiungere");
            setShowAlert(true);
            return;
        }

        const formData = new FormData()
        if (user !== null && marker) 
        {
            const shore = (document.querySelector('ion-select[name="shore"]') as HTMLIonSelectElement)?.value || '';
            formData.append("user_token", user?.token)
            formData.append("styleUrl", data.styleUrl)
            // formData.append("mark_type", data.extendedData_Tipo.indexOf("boa-") > -1 ? "buoy" : "signal") // not needed anymore
            // formData.append("sign_slug", data.slug) // not needed anymore            
            
            formData.append("extendedData_Tipo", data.extendedData_Tipo) // default value
            // in case of "chiamata" or "rimando" the shore will tell us which image
            // to use as the signal changes meaning from one side of the river to the other
            if (data.extendedData_Tipo == "Chiamata")
            {
              if (shore == "Destra")
              {
                formData.append("styleUrl", "#icon-ci-1") // override default value
              }
              else if (shore == "Sinistra")
              {
                formData.append("styleUrl", "#icon-ci-2") // override default value
              }
            }
            else if (data.extendedData_Tipo == "Rimando")
            {
              if (shore == "Destra")
              {
                formData.append("styleUrl", "#icon-ci-2") // override default value
              }
              else if (shore == "Sinistra")
              {
                formData.append("styleUrl", "#icon-ci-1") // override default value
              }
            }

            formData.append("point_lat", JSON.stringify(marker.latitude))
            formData.append("point_lng", JSON.stringify(marker.longitude))
            formData.append("description", (document.querySelector('ion-textarea[name="description"]') as HTMLIonTextareaElement)?.value || '')
            formData.append("shore", shore)
            
            const url = `${BASE_URL}/poServer.php?h=gkzLoFk0MN58TGqCJj&act=11`;
            fetch(url, {
                method: 'post',
                mode: 'cors', // this has to be 'cors'
                body: formData,
                headers: {
                    'Accept': 'application/json'
                }
            })
                .then(res => res.json())
                .then((response) => {
                    if (response.code === 200) 
                    {
                        setMessage(response?.txt)
                        setShowAlert(true)
                        fetchSigns();
                    } 
                    else if (response.code === 401)
                    {
                      setMessage(response?.error)
                      setShowAlert(true)
                    }
                    else 
                    {
                        setMessage(response?.txt)
                        setShowAlert(true)
                        handleLogout()
                    }
                })
                .catch(error => {
                    console.log(error)
                    setMessage(error)
                    setShowAlert(true)
                });
        }
    }

    const handleLogout = async () => {
        await localStore.remove('user')
        await dispatch({ type: ActionType.SET_USER, payload: null })
    }

    const handleMapLoad = () => {
        if (mapRef.current) {
          mapRef?.current?.getMap()?.resize();
        }
    };

    const handleMapZoom = (zoom: number) => {
      // Define zoom level thresholds and their corresponding marker classes
      const zoomLevels = [
        { level: 8, class: 'visible-marker-15' },
        { level: 9, class: 'visible-marker-5' },
        { level: 10, class: 'visible-marker-3' }, 
        { level: 11, class: 'visible-marker-2' },
        { level: 12, class: 'visible-marker-other' }
      ];
  
      // Handle visibility for each marker class based on zoom level
      zoomLevels.forEach(({ level, class: markerClass }) => {
        const display = zoom > level ? 'block' : 'none';
        Array.from(document.getElementsByClassName(markerClass))
          .forEach((element: any) => {
            element.style.display = display;
          });
      });
  
      // Handle batimetric name labels
      const batimetricElements = Array.from(document.getElementsByClassName('batimetric-name'));
      batimetricElements.forEach((element: any) => {
        element.style.display = zoom > 11 ? 'block !important' : 'none';
      });
    }

    async function fetchSigns() 
    {
      // if (signsList == null) 
      // {
        try 
        {
          const signs = await signsService.fetchSigns();
          if (signs) 
          {
            setSignsList(signs);
          } 
          else 
          {
            setMessage('Non sono presenti informazioni sulla segnaletica in memoria - riavviare l\'app e  riprovare');
            setShowAlert(true);
          }
        } 
        catch (error) 
        {
            setMessage('Non sono presenti informazioni sulla segnaletica in memoria - riavviare l\'app e  riprovare');
            setShowAlert(true);
        }
      // }
    }

  function openSignPopup(index: number, sign: any) 
  {
    console.log('openSignPopup :: styleUrl: ' + sign.styleUrl);
    setSelectedSignIndex(index);
    setOriginalPosition({longitude: sign.point_lng, latitude: sign.point_lat});
    setPosition({longitude: sign.point_lng, latitude: sign.point_lat});
  }

  function closeSignPopup() 
  {
    setSelectedSignIndex(null);
    setEditingSignIndex(null); // Reset editing state when closing popup
  }

  function closeEditingSignPopup() 
  {
    setEditingStart(true);
  }

  async function deleteSign(index: number) 
  {
    closeSignPopup();
    console.log('deleteSign :: index: ' + index);
    // send to the server a delete request to remove the sign from the map
    try 
    {
      const response = await signsService.deleteSign(index, user!.token);
      if (response) 
      {
        // console.log('deleteSign :: response: ', response);

        // Remove sign from local list
        const newSignsList = [...signsList!];
        newSignsList.splice(selectedSignIndex!, 1);
        setSignsList(newSignsList as [any]);
        setMessage('Segnaletica rimossa correttamente.');
        setShowAlert(true);
      } 
      else 
      {
        setMessage('Errore durante la rimozione del segnale - riprovare 1' + response.txt);
        setShowAlert(true);
      }
    } 
    catch (error) 
    {
      setMessage('Errore durante la rimozione del segnale - riprovare 2' + error);
      setShowAlert(true);
    }
  }

    function getSignIcon(sign: any)
    {
      // console.log('getSignIcon :: sign: ' + sign.styleUrl);
      if (sign.styleUrl	== "#icon-ci-1")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/rimando-icon-ci-1.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-2")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/chiamata-icon-ci-2.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-3")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/prosecuzione-icon-ci-3.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-4")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/tocca-scappa-icon-ci-4.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-5")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/campata-navigabile-icon-ci-5.svg`} className="dock-sign-icon-small"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-6")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/navigare-prudenza-icon-ci-6.svg`} className="dock-sign-icon"></IonIcon>;
      // else if (sign.styleUrl	== "#icon-ci-7") // not present in the list
      //   return <IonIcon icon={} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-8")
        return <div className="buoy-sign-icon-container"><IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/boa-bianca-icon-ci-8.svg`} className="buoy-legend-icon"></IonIcon></div>;
      else if (sign.styleUrl	== "#icon-ci-9-2")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/ostacoli-icon-ci-9-3.svg`} className="buoy-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-10")
        return <div className="buoy-sign-icon-container"><IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/boa-rossa-icon-ci-10.svg`} className="buoy-legend-icon"></IonIcon></div>;
      else if (sign.styleUrl	== "#icon-ci-11")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/direzione-icon-ci-11.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-11-sx")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/direzione-icon-ci-11-sx.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-12")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/divieto-transito-icon-ci-14.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-13")
        return <IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/obbligo-fermata-icon-ci-13.svg`} className="dock-sign-icon"></IonIcon>;
      else if (sign.styleUrl	== "#icon-ci-14")
        return <div className="buoy-sign-icon-container"><IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/boa-bianca-icon-ci-8.svg`} className="buoy-legend-icon-blink"></IonIcon></div>;
      else if (sign.styleUrl	== "#icon-ci-15")
        return <div className="buoy-sign-icon-container"><IonIcon icon={`${process.env.PUBLIC_URL}/assets/images/signs/boa-rossa-icon-ci-10.svg`} className="buoy-legend-icon-blink"></IonIcon></div>;
    }

    // Add this new function to handle marker drag end for existing signs
    const onExistingMarkerDragEnd = useCallback((event: MarkerDragEvent, signId: number) => {
        const newPosition = {
            longitude: event.lngLat.lng,
            latitude: event.lngLat.lat
        };
        setPosition(newPosition);
        console.log('onExistingMarkerDragEnd :: newPosition: ', newPosition);
        console.log('onExistingMarkerDragEnd :: oldPosition: ', originalPosition);
        console.log('onExistingMarkerDragEnd :: signId: ', signId);

        setEditingStart(false); // Reset editing state when closing popup

      }, [signsList, user]);

      function updateSignPosition(signId: number, newPosition: { longitude: number, latitude: number }) 
      {        
        // Update the sign position in the database
        signsService.updateSignPosition(signId, newPosition, user!.token)
            .then(() => {
                // Update local state
                const newSignsList = [...signsList!];
                const signIndex = newSignsList.findIndex(sign => sign.id === signId);
                if (signIndex !== -1) 
                {
                    newSignsList[signIndex].point_lng = newPosition.longitude;
                    newSignsList[signIndex].point_lat = newPosition.latitude;
                    setSignsList(newSignsList as [any]);
                }
                setMessage('Posizione aggiornata con successo');
                setShowAlert(true);
                resetEditing();
                closeSignPopup();
            })
            .catch(error => {
                setMessage('Errore durante l\'aggiornamento della posizione');
                setShowAlert(true);
            });
      }

      function resetEditing() 
      {
        setEditingSignIndex(null);
        setEditingStart(false);
        setOriginalPosition({longitude: 0, latitude: 0});
        setPosition({longitude: 0, latitude: 0});
      }

    if (!user?.token)
        return <Redirect to={'/login'} />

    return (
        <IonPage>
            <IonHeader>
                <InnerMenu name={pageName} userType={user?.type} isLogoutVisible={user?.type !== null} />
            </IonHeader>
            <IonContent fullscreen>
                <IonItem lines="none">
                    <h1 className="mainTit" slot="start">{pageName}</h1>
                </IonItem>

                <IonAccordionGroup>
                  <IonAccordion value="legend">
                    <IonItem slot="header">
                      <h2>Aggiungi segnale</h2>
                    </IonItem>
                    {/* add signal option selection form */}
                    <IonGrid slot="content">
                        <form >
                            <IonRow>
                                <IonCol className="select-no-space" size="8">
                                    <CustomDropdown Signal={Signal} value={selectedSignal.slug} onChange={setSelectedSignal} />
                                </IonCol>
                                <IonCol className="select-no-space" size="4">
                                  <IonSelect name="shore" placeholder="Sponda" className="shore-select-area">
                                    <IonSelectOption value="Sinistra">Sinistra</IonSelectOption>
                                    <IonSelectOption value="Destra">Destra</IonSelectOption>
                                    <IonSelectOption value="Alveo">Alveo</IonSelectOption>
                                  </IonSelect>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                              <IonCol className="select-no-space" size="12">
                                <IonTextarea name="description" placeholder="Inserisci una descrizione o annotazione" className="description-textarea"></IonTextarea>
                              </IonCol>
                            </IonRow>
                            <IonRow>
                              <IonCol className="select-no-space" size="9">
                                <IonButton className="add-btn" type="button" onClick={() => addSignalPoint(selectedSignal)} disabled={!selectedSignal}>Aggiungi alla mappa</IonButton>
                              </IonCol>
                              <IonCol className="select-no-space" size="3">
                                <IonButton expand="block" className="info-signal-btn" fill="clear" onClick={() => setShowInfo(true)}>
                                  <IonIcon icon={informationCircleOutline}></IonIcon>
                                </IonButton>
                              </IonCol>
                            </IonRow>
                        </form>
                    </IonGrid>
                </IonAccordion>
              </IonAccordionGroup>

                {/* map view */}
                <Map
                    id="metoriMap"
                    ref={mapRef}
                    onLoad={handleMapLoad}
                    onZoom={(e) => handleMapZoom(e.viewState.zoom)}
                    onRotate={(e) => handleRotationChange(e.viewState.bearing)}
                    initialViewState={{
                        latitude: (marker.latitude),
                        longitude: (marker.longitude),
                        zoom: (userCoords ? 16 : 12)
                    }}
                    style={{ height: '82%' }}
                    mapStyle="mapbox://styles/ale-art/cl1qnhp6m00b715qglkvaxm6o"
                    mapboxAccessToken={MAPBOX_TOKEN}
                    onStyleData={activateGeolocator}
                >
                    {/* signal list marker */}
                    {signsList && signsList.map((sign, index) => (
                      <Marker 
                        key={index} 
                        longitude={selectedSignIndex == index && position.longitude != 0 ? position.longitude : sign.point_lng} 
                        latitude={selectedSignIndex == index && position.latitude != 0 ? position.latitude : sign.point_lat} 
                        onClick={() => openSignPopup(index, sign)} 
                        anchor="bottom" 
                        offset={[0, -20]}
                        draggable={editingSignIndex === index}
                        onDragEnd={(e) => onExistingMarkerDragEnd(e, sign.id)}
                      >
                        <div className={`visible-marker-${index % 5 == 0 ? '5' : index % 3 == 0 ? '3' : index % 2 == 0 ? '2' : index % 7 == 0 ? '7' : 'other'}`}>
                          {getSignIcon(sign)}
                        </div>
                      </Marker>
                    ))
                    }

                    {/* draggable marker at current position */}
                    <Marker scale={2}
                        longitude={marker.longitude}
                        latitude={marker.latitude}
                        anchor="bottom"
                        draggable
                        color="red"
                        onDragStart={onMarkerDragStart}
                        onDrag={onMarkerDrag}
                        onDragEnd={onMarkerDragEnd}
                    >
                    </Marker>
                    {/* add popup on sign */}
                    {signsList && selectedSignIndex && !editingStart &&
                      <Popup
                        latitude={position.latitude == 0 ? signsList![selectedSignIndex].point_lat : position.latitude}
                        longitude={position.longitude == 0 ? signsList![selectedSignIndex].point_lng : position.longitude}
                        onClose={() => {
                            closeSignPopup();
                        }}
                        closeOnClick={false}
                        offset={100}
                        className="mapPopup"
                      >
                        <h2>{signsList![selectedSignIndex].extendedData_Tipo}</h2>
                        <p>{signsList![selectedSignIndex].extendedData_Localita} - {signsList![selectedSignIndex].extendedData_Nome_Local}</p>
                        <p>{signsList![selectedSignIndex].tratto} - {signsList![selectedSignIndex].presidio}</p>
                        <p>Note: {signsList![selectedSignIndex].extendedData_Descrizion}</p>
                        <p>Sponda: {signsList![selectedSignIndex].shore}</p>
                        <div style={{textAlign: 'right'}}>
                          <IonButton 
                            onClick={() => {
                              if (originalPosition.longitude !== position.longitude || originalPosition.latitude !== position.latitude)
                              {
                                updateSignPosition(signsList![selectedSignIndex].id, position);
                              }
                              else
                              {
                                setEditingSignIndex(selectedSignIndex);
                                closeEditingSignPopup();
                              }
                            }}
                            color="primary"
                            style={{marginRight: '8px'}}
                          >
                            {editingSignIndex === selectedSignIndex ? 'SALVA' : 'SPOSTA'}
                          </IonButton>
                          <IonButton color="warning" onClick={() => {resetEditing(); closeSignPopup();}}>
                            ANNULLA
                          </IonButton>
                          <IonButton color="danger" onClick={() => deleteSign(signsList![selectedSignIndex].id)}>
                            ELIMINA
                          </IonButton>
                        </div>
                      </Popup>
                    }
                    <GeolocateControl showUserLocation={false} trackUserLocation={true} showAccuracyCircle={true} showUserHeading={true} />
                    <Source
                        id="openseamap"
                        type="raster"
                        tiles={['https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png']}
                        tileSize={256}
                    />
                    <Layer
                        id="openseamap-layer"
                        type="raster"
                        source="openseamap"
                    />
                </Map>
            </IonContent>
            <GpsSinglePointComponent setUserCoords={setUserCoords} /> {/* pass the setter function to the child so we maintain the state watcher */}
            <IonAlert isOpen={showAlert} message={message} buttons={[{ text: 'Ok' }]} onDidDismiss={() => setShowAlert(false)} />
            <IonAlert isOpen={showInfo} message={"Per aggiungere un segnale o una boa, seleziona il segnale o la boa dall'elenco, selezionare la sponda e scrivere evenuali annotazioni, poi trascina col dito il puntatore rosso nella posizione desiderata e clicca su 'Aggiungi alla mappa'."} buttons={[{ text: 'Ok' }]} onDidDismiss={() => setShowInfo(false)} />
            <PageEventHandler pageIndex={14} dockIndex={0}/>
        </IonPage>
    )
}
export default Meatori